export enum AgendaItemStatus {
  Open = 'open',
  Completed = 'completed',
}

export enum AgendaItemStatusChangedBy {
  User = 'user',
  AI = 'ai',
}

export enum AgendaItemSource {
  User = 'user',
  AIGenerated = 'ai-generated',
  Fixed = 'fixed',
}

export interface AgendaItem {
  id: string
  text: string
  status: AgendaItemStatus
  statusChangedBy?: AgendaItemStatusChangedBy
  orderingIndex: number
  source: AgendaItemSource
}

export interface Agenda {
  id: string
  type: 'meeting'
  agendaKey: string
  items: AgendaItem[]
}
